import { batchListResponseType, batchResponseType } from '../types/apiResponse/batchTypes'
import { useBatchStore, BatchState } from '../store/batch/useBatchStore'
import { ARListResponseType } from '../types/apiResponse/activeRelationTypes'
import { useActiveRelationStore, ARState } from '../store/activeRelation/useActiveRelationStore'
import { TankListResponseType } from '../types/apiResponse/tankTypes'
import { useTankStore, TankState } from '../store/tank/useTankStore'
import { useSchoolStore } from '../store/school/useSchoolStore'
import { useTankRelationStore, TRState } from '../store/tankRelation/useTankRelationStore'
import { getARList, getBatchList, getSchool, getTankList } from '../api/layout'
import { schoolResponseType } from '../types/apiResponse/schoolTypes'

const storeBatches = (batches: batchListResponseType) => {
  const batchesById: BatchState = {}
  batches?.forEach((batch) => {
    batchesById[batch.batchId] = {
      batchName: batch.batchName,
      startDate: batch.startDate,
    }
  })
  batchesById['$unbatched'] = { batchName: 'Unbatched Tanks', startDate: 0 }
  batchesById['$empty'] = { batchName: 'Empty Tanks', startDate: 0 }
  useBatchStore.getState().setBatches(batchesById)
}

const storeActiveRelations = (activeRelations: ARListResponseType) => {
  const activeRelationsByBatch: ARState = {}
  activeRelations?.forEach((activeRelation) => {
    const currentBatchId =
      activeRelation.schoolId === null
        ? '$empty'
        : activeRelation.batchId === null
          ? '$unbatched'
          : activeRelation.batchId
    if (currentBatchId in activeRelationsByBatch) {
      activeRelationsByBatch[currentBatchId] = [
        ...activeRelationsByBatch[currentBatchId],
        {
          schoolId: activeRelation.schoolId,
          tankId: activeRelation.tankId,
        },
      ]
    } else {
      activeRelationsByBatch[currentBatchId] = [
        {
          schoolId: activeRelation.schoolId,
          tankId: activeRelation.tankId,
        },
      ]
    }
  })
  useActiveRelationStore.getState().setActiveRelations(activeRelationsByBatch)

  const tankRelations: TRState = {}
  activeRelations?.forEach((activeRelation) => {
    const currentBatchId =
      activeRelation.schoolId === null
        ? '$empty'
        : activeRelation.batchId === null
          ? '$unbatched'
          : activeRelation.batchId
    if (activeRelation.tankId in tankRelations) {
      tankRelations[activeRelation.tankId] = [
        ...tankRelations[activeRelation.tankId],
        {
          schoolId: activeRelation.schoolId,
          batchId: currentBatchId,
        },
      ]
    } else {
      tankRelations[activeRelation.tankId] = [
        {
          schoolId: activeRelation.schoolId,
          batchId: currentBatchId,
        },
      ]
    }
  })
  useTankRelationStore.getState().setTankRelations(tankRelations)
}

const storeTanks = (tanks: TankListResponseType) => {
  const tankStoreState: TankState = {}
  tanks?.forEach((tank) => {
    tankStoreState[tank.tankId] = {
      size: tank.size,
      location: tank.location,
      tankName: tank.tankName,
      maxDensity: tank.maxDensity,
    }
  })
  useTankStore.getState().setTanks(tankStoreState)
}

export const addSchool = (schoolResponse: schoolResponseType) => {
  const { schoolId, ...schoolInfo } = schoolResponse
  useSchoolStore.getState().addSchool(schoolId, schoolInfo)
}

export const delSchool = (schoolId: string) => {
  useSchoolStore.getState().delSchool(schoolId)
}

export const updateSchool = (schoolResponse: schoolResponseType) => {
  const { schoolId, ...schoolInfo } = schoolResponse
  useSchoolStore.getState().updateSchool(schoolId, schoolInfo)
}

export const delSchoolStoreMany = (schoolIdList: string[]) => {
  schoolIdList?.forEach((schoolId) => delSchool(schoolId))
}

export const reloadSchool = (schoolIdList: string[]) => {
  schoolIdList?.forEach((schoolId) =>
    getSchool(schoolId, (schoolResponse) => addSchool(schoolResponse)),
  )
}

export const addBatch = (batchResponse: batchResponseType) => {
  const { batchId, ...batchInfo } = batchResponse
  useBatchStore.getState().addBatch(batchId, batchInfo)
}

export const delBatch = (batchId: string) => {
  useBatchStore.getState().delBatch(batchId)
}

export const updateBatch = (batchResponse: batchResponseType) => {
  const { batchId, ...batchInfo } = batchResponse
  useBatchStore.getState().updateBatch(batchId, batchInfo)
}

export const reloadBatches = () => {
  getBatchList((batchResponse) => storeBatches(batchResponse))
}

export const reloadTanks = () => {
  getTankList((tankResponse) => storeTanks(tankResponse))
}

export const reloadActiveRelations = () => {
  getARList((activeRelationResponse) => storeActiveRelations(activeRelationResponse))
}
